import { render, staticRenderFns } from "./CreatorDetailCollection.vue?vue&type=template&id=7a572c1c&scoped=true&"
import script from "./CreatorDetailCollection.vue?vue&type=script&lang=js&"
export * from "./CreatorDetailCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a572c1c",
  null
  
)

export default component.exports